import { ACTIONS } from "../constants/actions";

export default (state = null, action) => {
  switch (action.type) {
    case ACTIONS.SET_JOBS:
      return action.payload
    default:
      return state
  }
}